import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StattunepsService} from 'src/app/modules/services/statestiques/stattuneps.service';

@Component({
    selector: 'app-statistiques',
    templateUrl: './statistiques.component.html',
    styleUrls: ['./statistiques.component.css']
})
export class StatistiquesComponent implements OnInit {

    public nbr_consultation = null;
    public nbr_acheteurs = null;
    public nbr_fournisseurs = null;
    public nbr_appels_offres = null;
    gridColumns = 4;

    constructor(private statservice: StattunepsService, private router: Router
    ) {
    }

    ngOnInit(): void {
        this.load_nbr_acheteurs();
        this.load_nbr_appels_offres();
        this.load_nbr_consultation();
        this.load_nbr_fournisseurs();
    }

    load_nbr_consultation() {


        this.statservice.load_nbr_consultation()
            .subscribe(response => {

                this.nbr_consultation = response['payload'];

            });


    }

    load_nbr_acheteurs() {


        this.statservice.load_nbr_acheteurs()
            .subscribe(response => {

                this.nbr_acheteurs = response['payload'];

            });


    }


    load_nbr_fournisseurs() {
        {

            this.statservice.load_nbr_fournisseurs()
                .subscribe(response => {

                    this.nbr_fournisseurs = response['payload'];

                });
        }

    }


    load_nbr_appels_offres() {


        this.statservice.load_nbr_appels_offres()
            .subscribe(response => {

                this.nbr_appels_offres = response['payload'];

            });


    }

    verstouslesstatistiques(): void {
        this.router.navigateByUrl('/portail/touslesstatistiques');
    }
}
